import { IFleet } from '../transferCompany/transferCompany';
import { IFile } from '../global/file';

export enum VehicleType {
  Sedan = 'SEDAN',
  Stationwagon = 'STATIONWAGON',
  Suv = 'SUV',
  Minivan = 'MINIVAN',
  BusinessLimousine = 'BUSINESS_LIMOUSINE',
  StretchLimousine = 'STRETCH_LIMOUSINE',
  TouringCar = 'TOURING_CAR',
  Minibus = 'MINIBUS',
  ExclusiveMinivan = 'EXCLUSIVE_MINIVAN',
  StandardElectricCar = 'STANDARD_ELECTRIC_CAR',
  LuxurySedan = 'LUXURY_SEDAN',
  HighEndElectricCar = 'HIGH_END_ELECTRIC_CAR',
  EconomySedan = 'ECONOMY_SEDAN',
  Shuttle = 'SHUTTLE',
  SpeedyShuttle = 'SPEEDY_SHUTTLE',
  DirectShuttle = 'DIRECT_SHUTTLE',
  Helicopter = 'HELICOPTER',
  BusinessSedan = 'BUSINESS_SEDAN',
  Coach = 'COACH',
  Van = 'VAN',
  Bus = 'BUS',
  MPV = 'MPV',
  EventShuttle = 'EVENT_SHUTTLE',
}

export const VehicleTypeDisplayName = {
  [VehicleType.Sedan]: 'Sedan',
  [VehicleType.StretchLimousine]: 'Stretch limousine',
  [VehicleType.Suv]: 'Suv',
  [VehicleType.Minivan]: 'Minivan',
  [VehicleType.BusinessLimousine]: 'Business limousine',
  [VehicleType.TouringCar]: 'Touring car',
  [VehicleType.StandardElectricCar]: 'Standard electric car',
  [VehicleType.LuxurySedan]: 'Luxury sedan',
  [VehicleType.HighEndElectricCar]: 'High end electric car',
  [VehicleType.Stationwagon]: 'Stationwagon',
  [VehicleType.Minibus]: 'Minibus',
  [VehicleType.ExclusiveMinivan]: 'Exclusive minivan',
  [VehicleType.EconomySedan]: 'Economy sedan',
  [VehicleType.Shuttle]: 'Shuttle',
  [VehicleType.SpeedyShuttle]: 'Speedy shuttle',
  [VehicleType.DirectShuttle]: 'Direct shuttle',
  [VehicleType.Helicopter]: 'Helicopter',
  [VehicleType.BusinessSedan]: 'Business sedan',
  [VehicleType.Coach]: 'Coach',
  [VehicleType.Bus]: 'Bus',
  [VehicleType.Van]: 'Van',
  [VehicleType.MPV]: 'MPV',
  [VehicleType.EventShuttle]: 'Event shuttle',
};

export interface IVehicle {
  id: number;
  fleetId: number;
  categories: string[];
  capacityPassengers: number;
  capacityLuggage: number;
  childSeatOption: boolean;
  color: string;
  licensePlate: string;
  vehicleMakeId: number;
  vehicleModelId: number;
  vehicleSeriesId: number;
  active: boolean;
  manufactureYear: number;
  photoFileId: number;
  excludedTravelAddons: string[];
  fleet: IFleet;
  vehicleMake?: IVehicleMake;
  vehicleModel?: IVehicleModel;
  vehicleSeries?: IVehicleSeries;
  photoFile: IFile;
}

export enum VehicleCategory {
  All = 'ALL',
  Specific = 'SPECIFIC',
}

export interface IVehicleMake {
  id: number;
  name: string;
}

export interface IVehicleModel {
  id: number;
  vehicleMakeId: number;
  name: string;
}

export interface IVehicleSeries {
  id: number;
  vehicleModelId: number;
  name: string;
}
